function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApiConstants from 'invision-core/src/api/constants';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { RESET_SUBSCRIBER_CREDIT_CLASSIFICATION, RETRIEVE_CREDIT_CLASSIFICATION_DETAILS, SET_CREDIT_CHECK_MODAL_STATUS, SET_CREDIT_CHECK_SKIPPED, UPDATE_CLASSIFICATION_METHOD_STATUS, UPDATE_CREDIT_CLASSIFICATION } from '../constants/credit.check.constants';
import { buildAddressesRequestObject, buildCreditCheckAddressRequestObject, buildCustomerForCreditCheck } from '../helpers/customer.helper';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
var RETRIEVE_CREDIT_CLASSIFICATION_DETAILS_EVENTS = [RETRIEVE_CREDIT_CLASSIFICATION_DETAILS.BEGIN, RETRIEVE_CREDIT_CLASSIFICATION_DETAILS.SUCCESS, RETRIEVE_CREDIT_CLASSIFICATION_DETAILS.FAILURE];
export var performCreditCheck = function performCreditCheck(subscriberCategory) {
  var subscriberId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var subscriberType = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch) {
    return performCreditCheckPromise(dispatch, subscriberCategory, subscriberId, subscriberType);
  };
};
export var setCreditCheckModalStatus = function setCreditCheckModalStatus(isModalOpen) {
  return {
    type: SET_CREDIT_CHECK_MODAL_STATUS,
    payload: isModalOpen
  };
};
export var setCreditCheckSkipped = function setCreditCheckSkipped(isSkipped) {
  return {
    type: SET_CREDIT_CHECK_SKIPPED,
    payload: isSkipped
  };
};
export var performCreditCheckPromise = function performCreditCheckPromise(dispatch, subscriberCategory, subscriberId, subscriberType) {
  var headers = {};
  if (subscriberId) {
    headers[ApiConstants.SUBSCRIBER_ID_HEADER] = subscriberId;
  }
  return ThunkHelper(dispatch, RETRIEVE_CREDIT_CLASSIFICATION_DETAILS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveCreditClassificationDetails',
    data: {
      SubscriberCategory: subscriberCategory,
      SubscriberType: subscriberType
    },
    headers: headers
  });
};
export var resetSubscriberCreditClassification = function resetSubscriberCreditClassification() {
  return {
    type: RESET_SUBSCRIBER_CREDIT_CLASSIFICATION
  };
};
export var updateCreditClassification = function updateCreditClassification(dispatch, customer, address, creditCheckAddress, method, updateSubscriber, subscriberId) {
  var overrideCreditCheckClassificationID = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var overrideCreditCheckClassificationComment = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var requestObj = {
    Address: address.Addresses[0],
    Credentials: customer.Credentials,
    CreditCheckMethod: method,
    OverrideCreditCheckClassificationComment: overrideCreditCheckClassificationComment,
    OverrideCreditCheckClassificationId: overrideCreditCheckClassificationID,
    Subscriber: customer.Subscriber,
    SubscriberCategory: customer.Subscriber.Category,
    SubscriberType: convertStringToNumber(customer.Subscriber.SubscriberTypeCode),
    UpdateSubscriber: updateSubscriber
  };
  if (creditCheckAddress.City && creditCheckAddress.Country && creditCheckAddress.LineOne && creditCheckAddress.State && creditCheckAddress.State) {
    Object.assign(requestObj, {
      AddressForCreditCheck: creditCheckAddress
    });
  }
  return ThunkHelper(dispatch, [UPDATE_CREDIT_CLASSIFICATION.BEGIN, UPDATE_CREDIT_CLASSIFICATION.SUCCESS, UPDATE_CREDIT_CLASSIFICATION.FAILURE], {
    method: 'post',
    url: 'SubscriberManagement/UpdateCreditClassification',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: requestObj
  });
};
export var createOrUpdateCustomerAndRunCreditCheck = function createOrUpdateCustomerAndRunCreditCheck(newCustomerData, creditCheck, selectedSubscriberCreditCheckDetails) {
  var additionalData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    updateSubscriber: false,
    creditClassificationData: null,
    isDbss: null
  };
  return function (dispatch) {
    var addressesOption = buildAddressesRequestObject(newCustomerData, selectedSubscriberCreditCheckDetails.Address);
    var creditCheckAddress = buildCreditCheckAddressRequestObject(newCustomerData.AddressForCreditCheck);
    var method = creditCheck ? UPDATE_CLASSIFICATION_METHOD_STATUS.RUN_CREDIT_CHECK : UPDATE_CLASSIFICATION_METHOD_STATUS.SKIP_CREDIT_CHECK;
    var subscriberId = newCustomerData.Id ? newCustomerData.Id : additionalData.creditClassificationData ? additionalData.creditClassificationData.Subscriber.Id : undefined;
    // should not be modifying the reference of newCustomerData, will be fixed in ASCINV-319
    newCustomerData = buildCustomerForCreditCheck(newCustomerData, additionalData.creditClassificationData, additionalData.isDbss);
    return updateCreditClassification(dispatch, newCustomerData, addressesOption, creditCheckAddress, method, additionalData.updateSubscriber, subscriberId);
  };
};
export var overrideCreditClassification = function overrideCreditClassification(newCustomerData, selectedSubscriberCreditCheckDetails) {
  var additionalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    updateSubscriber: false,
    creditClassificationData: null,
    overrideCreditCheckClassificationID: null,
    overrideCreditCheckClassificationComment: null,
    isDbss: null
  };
  return function (dispatch) {
    var addressesOption = buildAddressesRequestObject(newCustomerData, selectedSubscriberCreditCheckDetails.Address);
    var creditCheckAddress = buildCreditCheckAddressRequestObject(newCustomerData.AddressForCreditCheck);
    var method = UPDATE_CLASSIFICATION_METHOD_STATUS.RE_RUN_CREDIT_CHECK;
    var subscriberId = additionalData.creditClassificationData ? additionalData.creditClassificationData.Subscriber.Id : undefined;
    newCustomerData = buildCustomerForCreditCheck(newCustomerData, additionalData.creditClassificationData, additionalData.isDbss);
    return updateCreditClassification(dispatch, newCustomerData, addressesOption, creditCheckAddress, method, additionalData.updateSubscriber, subscriberId, additionalData.overrideCreditCheckClassificationID, additionalData.overrideCreditCheckClassificationComment);
  };
};